<template>
  <div class="main-container page-container">
    <div class="info">
      <p>说明：</p>
      <p>1、计算标准保费时会优先按照您配置的的险种折标系数进行匹配，当按险种未匹配到时，会根据您配置的交费年限折标系数进行匹配。</p>
      <p>2、如果折标系数为空，按照100%处理，标准保费=规模保费。</p>
      <p>3、按交费年限折标只对长险生效，短险折标系数默认为100%。</p>
    </div>

    <Tabs v-model="tab" @on-click="clickTabs" v-if="$units.superviseShowVal()">
      <TabPane label="保险公司" name="company"></TabPane>
      <TabPane label="合作通道" name="channel"></TabPane>
    </Tabs>

    <div class="search-box min">
      <div class="input-item">
        <span class="label">{{ this.tab == 'company' ? '保司' : '通道' }}简称</span>
        <Input clearable v-model="name" placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">{{ this.tab == 'company' ? '保司' : '通道' }}code</span>
        <Input clearable v-model="code" placeholder="请输入" />
      </div>

      <div class="btn-item">
        <Button type="primary" @click="changePage(1)">查询</Button>
      </div>
    </div>

    <loading :isShow="tableLoading" />
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" @click="toConfigPage(row)">折标系数配置</span>
          </div>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="changePage" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
    return {
      tab: 'company',
      tableLoading: false,
      tableData: [], //产品折标率
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1, //当前页
      columns: [
        {
          title: '序号',
          align: 'center',
          width: 85,
          type: 'index'
        },
        {
          title: '保司code',
          key: 'code',
          align: 'center',
          minWidth: 200
        },
        {
          title: '保险公司简称',
          key: 'name',
          align: 'center',
          minWidth: 200
        },
        {
          title: '产品数量',
          key: 'productNum',
          align: 'center',
          minWidth: 200
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '130',
          fixed: 'right'
        }
      ],
      name: '',
      code: ''
    };
  },
  created() {
    this.getCompanyTable();
  },
  activated(){
    this.changePage()
  },
  methods: {
    // 保司列表
    getCompanyTable() {
      this.tableLoading = true;
      this.$http({
        url: '/buz/insuranceCompany/queryMerchant',
        type: 'POST',
        data: {
          conversionType:'1',
          pageSize: this.pageSize,
          pageNo: this.pageNum,
          name: this.name,
          code: this.code
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.tableLoading = false;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },

    // 通道列表
    getChannelTable() {
      this.tableLoading = true;
      this.$http({
        url: '/buz/insuranceChannel/queryMerchant',
        type: 'POST',
        data: {
          conversionType:'1',
          pageSize: this.pageSize,
          pageNo: this.pageNum,
          name: this.name,
          code: this.code
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.tableLoading = false;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },

    clickTabs() {
      this.name = '';
      this.code = '';
      this.changePage(1);
    },

    // 配置
    toConfigPage(item) {
      this.openPageTabTags(
          '/foldingLabelConfig/supplierFactorConfig', 
          { 
              supplierType: this.tab=='company'?1:2,
              supplierId: item.id,
              conversionType: 1
          }
      );
    },

    // 改变分页
    changePage(pageNum) {
      if(pageNum){
        this.pageNum = pageNum;
      }
      
      if (this.tab == 'company') {
        this.columns = [
          {
            title: '序号',
            align: 'center',
            width: 85,
            type: 'index'
          },
          {
            title: '保司code',
            key: 'code',
            align: 'center',
            minWidth: 200
          },
          {
            title: '保司简称',
            key: 'name',
            align: 'center',
            minWidth: 200
          },
          {
            title: '产品数量',
            key: 'productNum',
            align: 'center',
            minWidth: 200
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            width: '170',
            fixed: 'right'
          }
        ];
        this.getCompanyTable();
      } else {
        this.columns = [
          {
            title: '序号',
            align: 'center',
            width: 85,
            type: 'index'
          },
          {
            title: '通道code',
            key: 'code',
            align: 'center',
            minWidth: 200
          },
          {
            title: '通道简称',
            key: 'name',
            align: 'center',
            minWidth: 200
          },
          {
            title: '产品数量',
            key: 'productNum',
            align: 'center',
            minWidth: 200
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            width: '170',
            fixed: 'right'
          }
        ];
        this.getChannelTable();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .info {
    margin-bottom: 15px;
    color: #6E574A;
    line-height: 1.6;
    border-radius: 4px;
    background: linear-gradient(106deg, #FFF7EA 0%, #FFF1E8 100%);
    padding: 12px 24px;
    font-size: 13px;
  }
  /deep/ .ivu-tabs-tab {
    padding-top: 0 !important;
    font-size: 14px;
  }
  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ececec;
    }
    .ivu-tabs-ink-bar {
      display: none;
    }
    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515c6f;
    }
    .ivu-tabs-tab-active {
      position: relative;
      color: #236dff;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236dff;
      }
    }
  }
}
</style>
